export class Account {
    ProductId: string = '';
    UserName: string = '';
    pathToBrixxAnnual: string = '';
    pathToBrixxMonthly: string = '';
    pathToBrixxForecast: string = '';
    pathToChangeLicense: string = '';
    customerRef: number = 0;
    externalCustomerRef: string = '';
    subscriptionRef: string = '';
    priceOptionCodes: string = '';
}